<template>
    <div>
        <div class="selected-category d-flex mt-2 my-md-3">
            <button class="ob1-card ob1-card-selected selected-category-image p-0 me-1" @click="backHandler">
                <span class="lead d-block mx-1" v-html="title" />
                <img class="pb-1" :src="image" alt="">
            </button>
            <div>
                <slot />
                <Lien
                    class="d-none d-sm-block"
                    :is-button="true"
                    :is-mini="true"
                    :is-link-arrow-back="true"
                    :label="backLinkLabel"
                    @click="backHandler"
                />
            </div>
        </div>
        <Lien
            class="d-sm-none"
            :is-button="true"
            :is-mini="true"
            :is-link-arrow-back="true"
            :label="backLinkLabel"
            @click="backHandler"
        />
    </div>
</template>

<script>

import Lien from "../../../common/components/ob1/Lien.vue";

export default {
    name: "RecoverySimulatorSelectedCategory",
    components: {Lien},
    props: {
        title: {
            type: String,
            required: true
        },
        image: {
            type: String,
            required: true
        },
        backLinkLabel: {
            type: String,
            required: true
        },
    },
    methods: {
        backHandler() {
            this.$emit("back");
        }
    }
}
</script>

<style lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.selected-category img {
    height: px-to-rem(110);
}

.selected-category {
    align-items: center;
}

.selected-category-image {
    text-align: center;
    align-items: center;
    width: px-to-rem(140);
    background-color: white;
}

.sosh .selected-category-image {
    border-color: #eb0450;
}

</style>
